import { PRODUCTS } from "./actions";

export const initialState={
    loading:"true",
    error:"",
    products:[]
}

export const reducers=(state = initialState ,{type,payload})=>{
 switch (type) {
    case PRODUCTS.FETCH_SUCCESS:
        return{
            ...state,
            loading:false,
            products:payload,
            error:''

        }
    case PRODUCTS.FETCH_ERROR:
        return {
            ...state,
            loading:false,
            products:[],
            error:'something Went Wrong'
        }
  
 
    default:
       return state
 }
}